module.exports = __webpack_public_path__ + "img/ntk_nav_cancel_g.139e46c3.svg";